let parentOrigin = (function () {
    try {
        if (document.referrer) {
            return new URL(document.referrer).origin;
        }
    }
    catch (e) { }
    return "*";
})();
window.sendMessage = (message, origin) => {
    console.log(`sending message ${message} ${origin}`);
    try {
        window.parent.postMessage(message, parentOrigin);
    }
    catch (e) {
        console.warn(e);
    }
};
window.sendObject = (message, origin) => {
    window.parent.postMessage(message, parentOrigin);
};
window.triggerClick = (elt) => {
    elt.click();
};
window.openModal = (elt) => {
    const myModal = document.getElementById(elt);
    if (!myModal)
        return;
    myModal.classList.add("show");
    myModal.style.display = "block";
};
window.registerDotNetInstance = (instance) => {
    window.dotnetInstance = instance;
};
window.getBrowserLanguage = () => {
    try {
        const nav = navigator;
        return (nav.language || nav.userLanguage || "").toLowerCase();
    }
    catch (e) {
        return "";
    }
};
window.persistSession = (token, sessionId, wsUrl) => {
    console.log("[SESSION] iframe persistSession called", { token: token, sessionId: sessionId, wsUrl: wsUrl });
    try {
        const payload = { token: token, sessionId: sessionId, wsUrl: wsUrl };
        window.parent.postMessage({
            message: "UpdateSessionConfig",
            value: JSON.stringify(payload)
        }, parentOrigin);
        console.log("[SESSION] iframe persistSession posted UpdateSessionConfig to parent (origin=" + parentOrigin + ")");
    }
    catch (e) {
        console.error("[SESSION] iframe persistSession error:", e);
    }
};
window.addEventListener('message', event => {
    if (event.origin && event.origin !== "null" && parentOrigin === "*") {
        parentOrigin = event.origin;
    }
    const d = window.dotnetInstance;
    if (d) {
        d.invokeMethodAsync("parentMessageEvent", event.data);
    }
    else {
        console.log("no dotnet instance loaded");
    }
});
export {};
//# sourceMappingURL=webchatworker.js.map